import {
} from './types';

// eslint-disable-next-line import/prefer-default-export
export const getAvatarSize = (
  appearance: string,
): 'xsmall' | 'small' | 'medium' =>
  // eslint-disable-next-line no-nested-ternary
  appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
